import { FREE_MONTHS, offerFromTag } from '../functions/lib/free-time'

// The sign-up screens promise 6 months for a First 100 link only while places are left (Astra, 12 Oct 2026: the
// 101st sign-up was told 6 and given 3). The places count is the website's own (GET /api/public/places, open, kept
// five minutes); when it says they have all gone, `then` puts the screen's words back to the usual 3 months.
// Sign-up decides for certain (functions/api/signup.ts) and says which it gave.
export function whenFirst100Gone(tag: string | null, then: (words: string) => void): void {
  if (offerFromTag(tag) !== 'first-100') return
  void fetch('/api/public/places', { credentials: 'omit' })
    .then((r) => (r.ok ? r.json() : null))
    .then((d: { joined?: unknown; total?: unknown } | null) => {
      if (d && typeof d.joined === 'number' && typeof d.total === 'number' && d.joined >= d.total) then(`${FREE_MONTHS.standard} months`)
    })
    .catch(() => { /* the screen keeps the link's words; sign-up still says which it gave */ })
}

// What the set-up screen says when the last place went while it was being filled in: the round has the usual
// 3 months, and the account menu shows the last free day.
export const PLACES_GONE_WORDS = `The First 100 places have all gone, so your round has the usual ${FREE_MONTHS.standard} months free.`
// The same when a referral link's code wasn't found (billing stage 7).
export const REFERRAL_UNKNOWN_WORDS = `That referral link didn't work, so your round has the usual ${FREE_MONTHS.standard} months free. If someone recommended Roundly, email hello@roundly.work within 30 days and we'll sort it.`
